export default __webpack_public_path__ + "static/1864-446f51ce0a1e247984eb8fb5a8c5efef.gif";